import { render, staticRenderFns } from "./MurdochFooter.vue?vue&type=template&id=2dcfbc58&"
import script from "./MurdochFooter.vue?vue&type=script&lang=js&"
export * from "./MurdochFooter.vue?vue&type=script&lang=js&"
import style0 from "./MurdochFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports